export const PDF_ANNOTATIONS_VALUE_KEY = '__pdfAnnotations';

export type CustomReportPdfAnnotationType = 'text' | 'checkbox' | 'signature' | 'whiteout' | 'image';

export interface CustomReportPdfAnnotation {
  id: string;
  page: number;
  type: CustomReportPdfAnnotationType;
  x: number;
  y: number;
  width: number;
  height: number;
  value: string;
  // Text/signature annotations only: chosen text colour (hex) and font size (px/pt).
  color?: string;
  fontSize?: number;
}

export const parsePdfAnnotations = (values?: Record<string, string>): CustomReportPdfAnnotation[] => {
  const raw = values?.[PDF_ANNOTATIONS_VALUE_KEY];
  if (!raw) return [];

  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export const serialisePdfAnnotations = (annotations: CustomReportPdfAnnotation[]) => JSON.stringify(annotations);
